// helpers
import dayjs from "@/helpers/dayjs";

// interfaces
import { IRange } from "@/types/Global";

// api
import { createActivities } from "@/api/campaigns";


export const handleCreateActivity = async (campaignId: number, activityId: number, period?: IRange | null) => {
  const startDate = period && dayjs(new Date(period.start)).format("YYYY-MM-DD");
  const endDate = period && dayjs(new Date(period.end)).format("YYYY-MM-DD");

  const periodPayload = period && period.start && period.end
    ? { periods: [{ ranges: { start: startDate, end: endDate } }] }
    : {};

  await createActivities(
    campaignId,
    activityId,
    periodPayload,
  );
};
